import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useFriendStatus(id, initial = null) {
  const { token } = useUser();
  const [result, setResult] = useState(() => {
    if (initial !== null) {
      return { status: initial };
    }

    return null;
  });
  const [loading, setLoading] = useState(result === null);


  const fetchFriendStatus = useCallback(async () => {
    setLoading(true);
    const { response, data } = await API.fetchFriendStatus(token, id);

    if (response.ok) {
      setResult(data);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [token, id, setLoading, setResult]);

  useEffect(() => {
    if (initial === null) {
      fetchFriendStatus();
    }
  }, [id, initial]);

  return {
    loading,
    status: result?.status ?? "none",
    refresh: () => fetchFriendStatus(),
  };
}
